import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/error-boundary';
import { AppStateProvider } from './redux/store';
import reportWebVitals from './reportWebVitals';
import { BannerProvider } from './components/common/BannerStateProvider';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppStateProvider>
        <BannerProvider {...{ bannerShown: false, bannerText: "" }}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </BannerProvider>
      </AppStateProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
